import { http } from '@/shared/api';

export interface SupportRequestBody {
  subject: string;
  message: string;
}

export function createSupportRequest(body: SupportRequestBody): Promise<void> {
  return http<void>('/support/requests', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
